import { put, call } from 'redux-saga/effects';
import { activityLogList } from '../services/activityLogService';

import * as types from '../actions';

export function* activityLogListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER}); 
    const response = yield call(activityLogList, payload);
    yield put({ type: types.ACTIVITY_LOG_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.ACTIVITY_LOG_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}